import React from 'react';
import { motion } from 'framer-motion';

const sparkleVariants = {
  initial: {
    scale: 0,
    opacity: 0,
  },
  animate: (i: number) => ({
    scale: [0, 1, 0],
    opacity: [0, 1, 0],
    transition: {
      delay: i * 0.05,
      duration: 0.7 + Math.random() * 0.5,
      ease: 'easeInOut',
    },
  }),
};

export function SparkleEffect({ count = 20 }: { count?: number }) {
  return (
    <div className="absolute inset-0 pointer-events-none">
      {Array.from({ length: count }).map((_, i) => (
        <motion.div
          key={i}
          custom={i}
          variants={sparkleVariants}
          initial="initial"
          animate="animate"
          className="absolute bg-yellow-400 rounded-full"
          style={{
            width: `${Math.random() * 8 + 4}px`,
            height: `${Math.random() * 8 + 4}px`,
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
          }}
        />
      ))}
    </div>
  );
}
